// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { LoginUserData, LoginUserResponses, LoginUserErrors, LogoutUserData, LogoutUserResponses, LogoutUserErrors, RequestPasswordResetData, RequestPasswordResetResponses, RequestPasswordResetErrors, ResetPasswordData, ResetPasswordResponses, ResetPasswordErrors, ActivateAccountData, ActivateAccountResponses, ActivateAccountErrors, RefreshAccessTokenData, RefreshAccessTokenResponses, RefreshAccessTokenErrors, VerifyEmailData, VerifyEmailResponses, VerifyEmailErrors, VerifySmsCodeData, VerifySmsCodeResponses, VerifySmsCodeErrors, SendOnboardingEmailData, SendOnboardingEmailResponses, SendOnboardingEmailErrors, ResendOnboardingEmailData, ResendOnboardingEmailResponses, ResendOnboardingEmailErrors, ResendEmailVerificationData, ResendEmailVerificationResponses, ResendEmailVerificationErrors, ResendSmsVerificationData, ResendSmsVerificationResponses, ResendSmsVerificationErrors, GetSchoolInfoData, GetSchoolInfoResponses, GetSchoolInfoErrors, ListPublicPackagesData, ListPublicPackagesResponses, ListPublicPackagesErrors, GetPackageAgreementData, GetPackageAgreementResponses, GetPackageAgreementErrors, RegisterUserData, RegisterUserResponses, RegisterUserErrors, GetGeneralStudentAgreementData, GetGeneralStudentAgreementResponses, GetGeneralStudentAgreementErrors, UpdateGeneralStudentAgreementData, UpdateGeneralStudentAgreementResponses, UpdateGeneralStudentAgreementErrors, GetIssuedFormByTokenData, GetIssuedFormByTokenResponses, GetIssuedFormByTokenErrors, GetUserData, GetUserResponses, GetUserErrors, ListUserActivityData, ListUserActivityResponses, ListUserActivityErrors, UpdateUserStatusData, UpdateUserStatusResponses, UpdateUserStatusErrors, GetInstructorByIdData, GetInstructorByIdResponses, GetInstructorByIdErrors, ListInstructorsData, ListInstructorsResponses, ListInstructorsErrors, ListStudentsData, ListStudentsResponses, ListStudentsErrors, GetStudentData, GetStudentResponses, GetStudentErrors, UpdateStudentData, UpdateStudentResponses, UpdateStudentErrors, ListStudentCourseEnrollmentsData, ListStudentCourseEnrollmentsResponses, ListStudentCourseEnrollmentsErrors, ListSelfSchedulePeriodsData, ListSelfSchedulePeriodsResponses, ListSelfSchedulePeriodsErrors, CountSelfSchedulePeriodsData, CountSelfSchedulePeriodsResponses, CountSelfSchedulePeriodsErrors, GetStudentSelfScheduleEligibilityData, GetStudentSelfScheduleEligibilityResponses, GetStudentSelfScheduleEligibilityErrors, GetStudentLedgerData, GetStudentLedgerResponses, GetStudentLedgerErrors, GetStudentScheduleData, GetStudentScheduleResponses, GetStudentScheduleErrors, UpdateStudentPermitData, UpdateStudentPermitResponses, UpdateStudentPermitErrors, ListStudentIssuedFormsData, ListStudentIssuedFormsResponses, ListStudentIssuedFormsErrors, SearchStudentsData, SearchStudentsResponses, SearchStudentsErrors, ListPackagesData, ListPackagesResponses, ListPackagesErrors, GetPackageData, GetPackageResponses, GetPackageErrors, UpdatePackageData, UpdatePackageResponses, UpdatePackageErrors, UpdatePackageAgreementData, UpdatePackageAgreementResponses, UpdatePackageAgreementErrors, ListCoursesData, ListCoursesResponses, ListCoursesErrors, GetCourseData, GetCourseResponses, GetCourseErrors, GetCoursePolicyData, GetCoursePolicyResponses, GetCoursePolicyErrors, UpdateCoursePolicyData, UpdateCoursePolicyResponses, UpdateCoursePolicyErrors, GetSelfScheduleCriteriaData, GetSelfScheduleCriteriaResponses, GetSelfScheduleCriteriaErrors, UpdateSelfScheduleCriteriaData, UpdateSelfScheduleCriteriaResponses, UpdateSelfScheduleCriteriaErrors, GetCourseEnrollmentCriteriaData, GetCourseEnrollmentCriteriaResponses, GetCourseEnrollmentCriteriaErrors, UpdateCourseEnrollmentCriteriaData, UpdateCourseEnrollmentCriteriaResponses, UpdateCourseEnrollmentCriteriaErrors, GetCourseCompletionCriteriaData, GetCourseCompletionCriteriaResponses, GetCourseCompletionCriteriaErrors, UpdateCourseCompletionCriteriaData, UpdateCourseCompletionCriteriaResponses, UpdateCourseCompletionCriteriaErrors, UpdateCourseAgreementData, UpdateCourseAgreementResponses, UpdateCourseAgreementErrors, UpdatePeriodEnrollmentData, UpdatePeriodEnrollmentResponses, UpdatePeriodEnrollmentErrors, UpdatePeriodEnrollmentPrivateNotesData, UpdatePeriodEnrollmentPrivateNotesResponses, UpdatePeriodEnrollmentPrivateNotesErrors, ListCourseSectionsData, ListCourseSectionsResponses, ListCourseSectionsErrors, GetCourseSectionData, GetCourseSectionResponses, GetCourseSectionErrors, ListSectionEnrollmentsData, ListSectionEnrollmentsResponses, ListSectionEnrollmentsErrors, ListSectionPeriodsData, ListSectionPeriodsResponses, ListSectionPeriodsErrors, GetCourseInstructorPoolData, GetCourseInstructorPoolResponses, GetCourseInstructorPoolErrors, TakeAttendanceData, TakeAttendanceResponses, TakeAttendanceErrors, SearchSectionEnrollmentsData, SearchSectionEnrollmentsResponses, SearchSectionEnrollmentsErrors, EnrollStudentInSectionData, EnrollStudentInSectionResponses, EnrollStudentInSectionErrors, GetCourseEnrollmentData, GetCourseEnrollmentResponses, GetCourseEnrollmentErrors, UpdateEnrollmentCompletionDateData, UpdateEnrollmentCompletionDateResponses, UpdateEnrollmentCompletionDateErrors, IssueCertificateData, IssueCertificateResponses, IssueCertificateErrors, GetCoursePeriodData, GetCoursePeriodResponses, GetCoursePeriodErrors, UpdateCoursePeriodData, UpdateCoursePeriodResponses, UpdateCoursePeriodErrors, ListPeriodEnrollmentsData, ListPeriodEnrollmentsResponses, ListPeriodEnrollmentsErrors, ListCourseEnrollmentPeriodsData, ListCourseEnrollmentPeriodsResponses, ListCourseEnrollmentPeriodsErrors, CancelPeriodEnrollmentData, CancelPeriodEnrollmentResponses, CancelPeriodEnrollmentErrors, DeleteCoursePeriodsData, DeleteCoursePeriodsResponses, DeleteCoursePeriodsErrors, ListCoursePeriodsData, ListCoursePeriodsResponses, ListCoursePeriodsErrors, CreateCoursePeriodsData, CreateCoursePeriodsResponses, CreateCoursePeriodsErrors, EnrollStudentInPeriodData, EnrollStudentInPeriodResponses, EnrollStudentInPeriodErrors, EnrollStudentInPeriodWaitlistData, EnrollStudentInPeriodWaitlistResponses, EnrollStudentInPeriodWaitlistErrors, DeletePeriodEnrollmentData, DeletePeriodEnrollmentResponses, DeletePeriodEnrollmentErrors, ListFormTemplatesData, ListFormTemplatesResponses, ListFormTemplatesErrors, GetFormTemplateData, GetFormTemplateResponses, GetFormTemplateErrors, IssueFormData, IssueFormResponses, IssueFormErrors, IssueIndianaEnrollmentCertificationFormData, IssueIndianaEnrollmentCertificationFormResponses, IssueIndianaEnrollmentCertificationFormErrors, IssueIndianaCompletionPermitFormData, IssueIndianaCompletionPermitFormResponses, IssueIndianaCompletionPermitFormErrors, GetIssuedFormData, GetIssuedFormResponses, GetIssuedFormErrors, GetIssuedFormLinkData, GetIssuedFormLinkResponses, GetIssuedFormLinkErrors, EmailIssuedFormData, EmailIssuedFormResponses, EmailIssuedFormErrors, GetCalendarFeedData, GetCalendarFeedResponses, GetCalendarFeedErrors, DeleteChargeData, DeleteChargeResponses, DeleteChargeErrors, ListChargesData, ListChargesResponses, ListChargesErrors, CreateChargeData, CreateChargeResponses, CreateChargeErrors, GetChargeData, GetChargeResponses, GetChargeErrors, UpdateChargeData, UpdateChargeResponses, UpdateChargeErrors, VoidChargeData, VoidChargeResponses, VoidChargeErrors, ListPaymentsData, ListPaymentsResponses, ListPaymentsErrors, CreatePaymentData, CreatePaymentResponses, CreatePaymentErrors, GetPaymentData, GetPaymentResponses, GetPaymentErrors, UpdatePaymentData, UpdatePaymentResponses, UpdatePaymentErrors, VoidPaymentData, VoidPaymentResponses, VoidPaymentErrors, ListDiscountsData, ListDiscountsResponses, ListDiscountsErrors, ListPaymentMethodsData, ListPaymentMethodsResponses, ListPaymentMethodsErrors, ListRefundsData, ListRefundsResponses, ListRefundsErrors, CreateRefundData, CreateRefundResponses, CreateRefundErrors, GetRefundData, GetRefundResponses, GetRefundErrors, UpdateRefundData, UpdateRefundResponses, UpdateRefundErrors, VoidRefundData, VoidRefundResponses, VoidRefundErrors, GetTemplateData, GetTemplateResponses, GetTemplateErrors, UpdateTemplateData, UpdateTemplateResponses, UpdateTemplateErrors, ListReportsData, ListReportsResponses, ListReportsErrors, GetReportData, GetReportResponses, GetReportErrors, GenerateReportData, GenerateReportResponses, GenerateReportErrors, GetMyLearningCoursesData, GetMyLearningCoursesResponses, GetMyLearningCoursesErrors, ListCurriculaData, ListCurriculaResponses, ListCurriculaErrors, CreateCurriculumData, CreateCurriculumResponses, CreateCurriculumErrors, GetCurriculumData, GetCurriculumResponses, GetCurriculumErrors, UpdateCurriculumData, UpdateCurriculumResponses, UpdateCurriculumErrors, PublishCurriculumData, PublishCurriculumResponses, PublishCurriculumErrors, GetCourseCurriculumAssignmentData, GetCourseCurriculumAssignmentResponses, AssignCurriculumToCourseData, AssignCurriculumToCourseResponses, GetLearningCourseData, GetLearningCourseResponses, GetLearningCourseErrors, UpdateLearningProgressData, UpdateLearningProgressResponses, SubmitLearningQuizData, SubmitLearningQuizResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * User login
 * Authenticate a user with username and password
 */
export const loginUser = <ThrowOnError extends boolean = false>(options: Options<LoginUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoginUserResponses, LoginUserErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Logout
 * Logout
 */
export const logoutUser = <ThrowOnError extends boolean = false>(options?: Options<LogoutUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogoutUserResponses, LogoutUserErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/auth/logout',
        ...options
    });
};

/**
 * Request a password reset link
 * Send user a password reset link
 */
export const requestPasswordReset = <ThrowOnError extends boolean = false>(options: Options<RequestPasswordResetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestPasswordResetResponses, RequestPasswordResetErrors, ThrowOnError>({
        url: '/public/auth/forgotPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * User password reset
 * Resets a users password
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
        url: '/public/auth/resetPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Activate imported user account
 * Activates an imported user account by setting their password
 */
export const activateAccount = <ThrowOnError extends boolean = false>(options: Options<ActivateAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActivateAccountResponses, ActivateAccountErrors, ThrowOnError>({
        url: '/public/auth/onboarding/activate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Request new access token
 * Use refresh token to get a new access token
 */
export const refreshAccessToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshAccessTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RefreshAccessTokenResponses, RefreshAccessTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/auth/refresh',
        ...options
    });
};

/**
 * Verify a user's email using a token
 * Marks a user's or parent's email as verified using a JWT token.
 *
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/auth/email/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify a user's phone number using an OTP code
 * Marks a user's or parent's phone number as verified using a one-time password (OTP) code. Requires authentication.
 *
 */
export const verifySmsCode = <ThrowOnError extends boolean = false>(options: Options<VerifySmsCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifySmsCodeResponses, VerifySmsCodeErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/sms/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send onboarding email to imported user
 * Sends onboarding email to a user without a password (admin/instructor only)
 */
export const sendOnboardingEmail = <ThrowOnError extends boolean = false>(options: Options<SendOnboardingEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendOnboardingEmailResponses, SendOnboardingEmailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/onboarding/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resend user onboarding email (activation link)
 * Resends the user's onboarding email with activation link (admin/instructor only).
 *
 * **IMPORTANT:** This endpoint ONLY resends the user's onboarding email.
 * For parent email verification resends, use `POST /public/auth/email/resend` instead.
 *
 * The user must have a pending onboarding request (not yet activated).
 *
 */
export const resendOnboardingEmail = <ThrowOnError extends boolean = false>(options: Options<ResendOnboardingEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResendOnboardingEmailResponses, ResendOnboardingEmailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/onboarding/resend',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resend email verification
 * Resends an email verification message. Finds the most recent pending verification request for the email address and generates a new JWT token.
 *
 */
export const resendEmailVerification = <ThrowOnError extends boolean = false>(options: Options<ResendEmailVerificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResendEmailVerificationResponses, ResendEmailVerificationErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/auth/email/resend',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resend SMS verification (authenticated)
 * Resends an SMS verification message. Requires authentication and uses the authenticated user's ID to scope the verification request.
 *
 */
export const resendSmsVerification = <ThrowOnError extends boolean = false>(options: Options<ResendSmsVerificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResendSmsVerificationResponses, ResendSmsVerificationErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/sms/resend',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get School Info
 */
export const getSchoolInfo = <ThrowOnError extends boolean = false>(options?: Options<GetSchoolInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSchoolInfoResponses, GetSchoolInfoErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/info',
        ...options
    });
};

/**
 * Get Packages
 */
export const listPublicPackages = <ThrowOnError extends boolean = false>(options?: Options<ListPublicPackagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPublicPackagesResponses, ListPublicPackagesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/packages',
        ...options
    });
};

/**
 * Get combined agreement for a package
 * Returns the agreement HTML for the package, along with a SHA256 hash.
 */
export const getPackageAgreement = <ThrowOnError extends boolean = false>(options: Options<GetPackageAgreementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPackageAgreementResponses, GetPackageAgreementErrors, ThrowOnError>({
        responseType: 'json',
        url: '/public/packages/{id}/agreement',
        ...options
    });
};

/**
 * Register a user
 */
export const registerUser = <ThrowOnError extends boolean = false>(options: Options<RegisterUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegisterUserResponses, RegisterUserErrors, ThrowOnError>({
        url: '/public/register/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the general student agreement for a tenant
 * Retrieves the general student agreement for the specified tenant, including the latest version.
 */
export const getGeneralStudentAgreement = <ThrowOnError extends boolean = false>(options: Options<GetGeneralStudentAgreementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGeneralStudentAgreementResponses, GetGeneralStudentAgreementErrors, ThrowOnError>({
        responseType: 'json',
        url: '/tenants/{tenantId}/agreements/general-student',
        ...options
    });
};

/**
 * Update the general student agreement for a tenant
 * Creates a new version of the tenant's general student agreement, or creates a new agreement if none exists. This is specific to the tenant’s "general student agreement".
 */
export const updateGeneralStudentAgreement = <ThrowOnError extends boolean = false>(options: Options<UpdateGeneralStudentAgreementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateGeneralStudentAgreementResponses, UpdateGeneralStudentAgreementErrors, ThrowOnError>({
        responseType: 'json',
        url: '/tenants/{tenantId}/agreements/general-student',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve an issued form using an access token
 * Retrieves the document associated with the provided JWT access token.
 * The token must be provided as a query parameter.
 *
 */
export const getIssuedFormByToken = <ThrowOnError extends boolean = false>(options: Options<GetIssuedFormByTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIssuedFormByTokenResponses, GetIssuedFormByTokenErrors, ThrowOnError>({
        responseType: 'json',
        url: '/documents/issued-form',
        ...options
    });
};

/**
 * Fetch User By Id
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserResponses, GetUserErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/{id}',
        ...options
    });
};

/**
 * Get user activity
 * Retrieve a list of activities for a specific user by their ID.
 */
export const listUserActivity = <ThrowOnError extends boolean = false>(options: Options<ListUserActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListUserActivityResponses, ListUserActivityErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/{id}/activity',
        ...options
    });
};

/**
 * Update user active status
 * Marks a user as active or inactive
 */
export const updateUserStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateUserStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateUserStatusResponses, UpdateUserStatusErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Instructor By Id
 */
export const getInstructorById = <ThrowOnError extends boolean = false>(options: Options<GetInstructorByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInstructorByIdResponses, GetInstructorByIdErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/instructors/{id}',
        ...options
    });
};

/**
 * Fetch Instructors
 */
export const listInstructors = <ThrowOnError extends boolean = false>(options: Options<ListInstructorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListInstructorsResponses, ListInstructorsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/instructors',
        ...options
    });
};

/**
 * Fetch Students
 */
export const listStudents = <ThrowOnError extends boolean = false>(options: Options<ListStudentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStudentsResponses, ListStudentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students',
        ...options
    });
};

/**
 * Fetch Student By Id
 */
export const getStudent = <ThrowOnError extends boolean = false>(options: Options<GetStudentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStudentResponses, GetStudentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}',
        ...options
    });
};

/**
 * Update Student by Id
 */
export const updateStudent = <ThrowOnError extends boolean = false>(options: Options<UpdateStudentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateStudentResponses, UpdateStudentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Students Course Enrollments
 */
export const listStudentCourseEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListStudentCourseEnrollmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStudentCourseEnrollmentsResponses, ListStudentCourseEnrollmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/courseEnrollments',
        ...options
    });
};

/**
 * Fetch course periods for self scheduled course enrollment
 */
export const listSelfSchedulePeriods = <ThrowOnError extends boolean = false>(options: Options<ListSelfSchedulePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListSelfSchedulePeriodsResponses, ListSelfSchedulePeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/courseEnrollments/{courseEnrollmentId}/selfSchedulePeriods',
        ...options
    });
};

/**
 * Count self scheduled course periods between two dates
 */
export const countSelfSchedulePeriods = <ThrowOnError extends boolean = false>(options: Options<CountSelfSchedulePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CountSelfSchedulePeriodsResponses, CountSelfSchedulePeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/courseEnrollments/{courseEnrollmentId}/countSelfSchedulePeriods',
        ...options
    });
};

/**
 * Get self-schedule eligibility for a course enrollment
 * Returns comprehensive eligibility information including all blocking rules and restrictions that prevent or limit a student from booking self-scheduled driving lessons.
 *
 */
export const getStudentSelfScheduleEligibility = <ThrowOnError extends boolean = false>(options: Options<GetStudentSelfScheduleEligibilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStudentSelfScheduleEligibilityResponses, GetStudentSelfScheduleEligibilityErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/courseEnrollments/{courseEnrollmentId}/selfScheduleEligibility',
        ...options
    });
};

/**
 * Fetch Ledger Student By Id
 */
export const getStudentLedger = <ThrowOnError extends boolean = false>(options: Options<GetStudentLedgerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStudentLedgerResponses, GetStudentLedgerErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/ledger',
        ...options
    });
};

/**
 * Fetch course periods by student id
 */
export const getStudentSchedule = <ThrowOnError extends boolean = false>(options: Options<GetStudentScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStudentScheduleResponses, GetStudentScheduleErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/schedule',
        ...options
    });
};

/**
 * Update permit by student ID
 */
export const updateStudentPermit = <ThrowOnError extends boolean = false>(options: Options<UpdateStudentPermitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateStudentPermitResponses, UpdateStudentPermitErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/permit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Issued Forms For Student By Id
 */
export const listStudentIssuedForms = <ThrowOnError extends boolean = false>(options: Options<ListStudentIssuedFormsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStudentIssuedFormsResponses, ListStudentIssuedFormsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/{id}/issuedForms',
        ...options
    });
};

/**
 * Search students
 */
export const searchStudents = <ThrowOnError extends boolean = false>(options?: Options<SearchStudentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchStudentsResponses, SearchStudentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/users/students/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get All Packages
 */
export const listPackages = <ThrowOnError extends boolean = false>(options?: Options<ListPackagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPackagesResponses, ListPackagesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/packages',
        ...options
    });
};

/**
 * Get All Packages
 */
export const getPackage = <ThrowOnError extends boolean = false>(options: Options<GetPackageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPackageResponses, GetPackageErrors, ThrowOnError>({
        responseType: 'json',
        url: '/packages/{id}',
        ...options
    });
};

/**
 * Update a Package
 */
export const updatePackage = <ThrowOnError extends boolean = false>(options: Options<UpdatePackageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePackageResponses, UpdatePackageErrors, ThrowOnError>({
        responseType: 'json',
        url: '/packages/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update the agreement for a specific package
 */
export const updatePackageAgreement = <ThrowOnError extends boolean = false>(options: Options<UpdatePackageAgreementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePackageAgreementResponses, UpdatePackageAgreementErrors, ThrowOnError>({
        responseType: 'json',
        url: '/packages/{id}/agreement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get All Courses
 */
export const listCourses = <ThrowOnError extends boolean = false>(options?: Options<ListCoursesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCoursesResponses, ListCoursesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses',
        ...options
    });
};

/**
 * Fetch Course By Id
 */
export const getCourse = <ThrowOnError extends boolean = false>(options: Options<GetCourseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseResponses, GetCourseErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}',
        ...options
    });
};

/**
 * Fetch Course Policy By Course Id
 */
export const getCoursePolicy = <ThrowOnError extends boolean = false>(options: Options<GetCoursePolicyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCoursePolicyResponses, GetCoursePolicyErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/policy',
        ...options
    });
};

/**
 * Update The Policy For A Course
 */
export const updateCoursePolicy = <ThrowOnError extends boolean = false>(options: Options<UpdateCoursePolicyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCoursePolicyResponses, UpdateCoursePolicyErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/policy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Course Policy By Course Id
 */
export const getSelfScheduleCriteria = <ThrowOnError extends boolean = false>(options: Options<GetSelfScheduleCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSelfScheduleCriteriaResponses, GetSelfScheduleCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/selfScheduleCriteria',
        ...options
    });
};

/**
 * Update The Self Schedule Criteria For A Course
 */
export const updateSelfScheduleCriteria = <ThrowOnError extends boolean = false>(options: Options<UpdateSelfScheduleCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSelfScheduleCriteriaResponses, UpdateSelfScheduleCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/selfScheduleCriteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Course Enollment Criteria By Course Id
 */
export const getCourseEnrollmentCriteria = <ThrowOnError extends boolean = false>(options: Options<GetCourseEnrollmentCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseEnrollmentCriteriaResponses, GetCourseEnrollmentCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/enrollmentCriteria',
        ...options
    });
};

/**
 * Update The Course Enollment Criteria For A Course
 */
export const updateCourseEnrollmentCriteria = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseEnrollmentCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCourseEnrollmentCriteriaResponses, UpdateCourseEnrollmentCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/enrollmentCriteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Course Completion Criteria By Course Id
 */
export const getCourseCompletionCriteria = <ThrowOnError extends boolean = false>(options: Options<GetCourseCompletionCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseCompletionCriteriaResponses, GetCourseCompletionCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/completionCriteria',
        ...options
    });
};

/**
 * Update The Course Completion Criteria For A Course
 */
export const updateCourseCompletionCriteria = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseCompletionCriteriaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCourseCompletionCriteriaResponses, UpdateCourseCompletionCriteriaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/completionCriteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update the agreement for a specific course
 */
export const updateCourseAgreement = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseAgreementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateCourseAgreementResponses, UpdateCourseAgreementErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/agreement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update public notes for a period enrollment
 */
export const updatePeriodEnrollment = <ThrowOnError extends boolean = false>(options: Options<UpdatePeriodEnrollmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePeriodEnrollmentResponses, UpdatePeriodEnrollmentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/enrollments/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update private notes for a period enrollment
 */
export const updatePeriodEnrollmentPrivateNotes = <ThrowOnError extends boolean = false>(options: Options<UpdatePeriodEnrollmentPrivateNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePeriodEnrollmentPrivateNotesResponses, UpdatePeriodEnrollmentPrivateNotesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/enrollments/private-notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Course Sections
 */
export const listCourseSections = <ThrowOnError extends boolean = false>(options: Options<ListCourseSectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCourseSectionsResponses, ListCourseSectionsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/sections',
        ...options
    });
};

/**
 * Fetch Section By Id
 */
export const getCourseSection = <ThrowOnError extends boolean = false>(options: Options<GetCourseSectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseSectionResponses, GetCourseSectionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/sections/{id}',
        ...options
    });
};

/**
 * Fetch Enrollments by Section By Id
 */
export const listSectionEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListSectionEnrollmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListSectionEnrollmentsResponses, ListSectionEnrollmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/sections/{id}/enrollments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Periods by Section By Id
 */
export const listSectionPeriods = <ThrowOnError extends boolean = false>(options: Options<ListSectionPeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListSectionPeriodsResponses, ListSectionPeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/sections/{id}/periods',
        ...options
    });
};

/**
 * Get All Instructors Eligible To Teach Course
 */
export const getCourseInstructorPool = <ThrowOnError extends boolean = false>(options: Options<GetCourseInstructorPoolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseInstructorPoolResponses, GetCourseInstructorPoolErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/{id}/instructorPool',
        ...options
    });
};

/**
 * Take Attendance For Course Period
 */
export const takeAttendance = <ThrowOnError extends boolean = false>(options: Options<TakeAttendanceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TakeAttendanceResponses, TakeAttendanceErrors, ThrowOnError>({
        url: '/courses/takeAttendance',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search enrollments for course section
 */
export const searchSectionEnrollments = <ThrowOnError extends boolean = false>(options?: Options<SearchSectionEnrollmentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchSectionEnrollmentsResponses, SearchSectionEnrollmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/searchSectionEnrollments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enroll a student in a course section
 */
export const enrollStudentInSection = <ThrowOnError extends boolean = false>(options: Options<EnrollStudentInSectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnrollStudentInSectionResponses, EnrollStudentInSectionErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/enrollStudentInSection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get course enrollment by id
 */
export const getCourseEnrollment = <ThrowOnError extends boolean = false>(options: Options<GetCourseEnrollmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseEnrollmentResponses, GetCourseEnrollmentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/enrollments/{id}',
        ...options
    });
};

/**
 * Update the completion date for a course enrollment
 * Updates the completion date of a specific course enrollment.
 */
export const updateEnrollmentCompletionDate = <ThrowOnError extends boolean = false>(options: Options<UpdateEnrollmentCompletionDateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateEnrollmentCompletionDateResponses, UpdateEnrollmentCompletionDateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/enrollments/{id}/completionDate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Issue a completion certificate for a course enrollment
 * Manually issue a completion certificate for a completed course enrollment. Requires ADMIN role.
 */
export const issueCertificate = <ThrowOnError extends boolean = false>(options: Options<IssueCertificateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssueCertificateResponses, IssueCertificateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/enrollments/{id}/certificate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Course Period
 */
export const getCoursePeriod = <ThrowOnError extends boolean = false>(options: Options<GetCoursePeriodData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCoursePeriodResponses, GetCoursePeriodErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/{id}',
        ...options
    });
};

/**
 * Update course period by ID
 * Update a specific course period using its unique identifier.
 */
export const updateCoursePeriod = <ThrowOnError extends boolean = false>(options: Options<UpdateCoursePeriodData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCoursePeriodResponses, UpdateCoursePeriodErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch Course Period Enrollments
 */
export const listPeriodEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListPeriodEnrollmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPeriodEnrollmentsResponses, ListPeriodEnrollmentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/{id}/enrollments',
        ...options
    });
};

/**
 * Fetch Course Periods For Course Enrollment
 */
export const listCourseEnrollmentPeriods = <ThrowOnError extends boolean = false>(options: Options<ListCourseEnrollmentPeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCourseEnrollmentPeriodsResponses, ListCourseEnrollmentPeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/getCourseEnrollmentPeriods',
        ...options
    });
};

/**
 * Cancel period enrollment
 */
export const cancelPeriodEnrollment = <ThrowOnError extends boolean = false>(options: Options<CancelPeriodEnrollmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelPeriodEnrollmentResponses, CancelPeriodEnrollmentErrors, ThrowOnError>({
        url: '/courses/periods/cancelEnrollment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete course periods
 * Delete multiple course periods using their unique identifiers.
 */
export const deleteCoursePeriods = <ThrowOnError extends boolean = false>(options: Options<DeleteCoursePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCoursePeriodsResponses, DeleteCoursePeriodsErrors, ThrowOnError>({
        url: '/courses/periods',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch All Course Periods
 */
export const listCoursePeriods = <ThrowOnError extends boolean = false>(options: Options<ListCoursePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCoursePeriodsResponses, ListCoursePeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods',
        ...options
    });
};

/**
 * Create new course periods
 */
export const createCoursePeriods = <ThrowOnError extends boolean = false>(options: Options<CreateCoursePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCoursePeriodsResponses, CreateCoursePeriodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enroll a student in a course period
 */
export const enrollStudentInPeriod = <ThrowOnError extends boolean = false>(options: Options<EnrollStudentInPeriodData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnrollStudentInPeriodResponses, EnrollStudentInPeriodErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/enrollStudentInPeriod',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enroll a student in a course period waitlist
 */
export const enrollStudentInPeriodWaitlist = <ThrowOnError extends boolean = false>(options: Options<EnrollStudentInPeriodWaitlistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnrollStudentInPeriodWaitlistResponses, EnrollStudentInPeriodWaitlistErrors, ThrowOnError>({
        responseType: 'json',
        url: '/courses/periods/enrollStudentInPeriodWaitlist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete course period enrollment
 */
export const deletePeriodEnrollment = <ThrowOnError extends boolean = false>(options: Options<DeletePeriodEnrollmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePeriodEnrollmentResponses, DeletePeriodEnrollmentErrors, ThrowOnError>({
        url: '/courses/periods/deletePeriodEnrollment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Tenant Forms
 */
export const listFormTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListFormTemplatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFormTemplatesResponses, ListFormTemplatesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms',
        ...options
    });
};

/**
 * Get Form
 */
export const getFormTemplate = <ThrowOnError extends boolean = false>(options: Options<GetFormTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFormTemplateResponses, GetFormTemplateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/{id}',
        ...options
    });
};

/**
 * Fill and Issue Form Template
 */
export const issueForm = <ThrowOnError extends boolean = false>(options: Options<IssueFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssueFormResponses, IssueFormErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/issue/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Issue Indiana CDE Form
 */
export const issueIndianaEnrollmentCertificationForm = <ThrowOnError extends boolean = false>(options: Options<IssueIndianaEnrollmentCertificationFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssueIndianaEnrollmentCertificationFormResponses, IssueIndianaEnrollmentCertificationFormErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/indiana/certificationOfDriverEducationEnrollment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate Indiana Completion of Driver Training School Course Permit Form
 */
export const issueIndianaCompletionPermitForm = <ThrowOnError extends boolean = false>(options: Options<IssueIndianaCompletionPermitFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssueIndianaCompletionPermitFormResponses, IssueIndianaCompletionPermitFormErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/indiana/completionOfDriverTrainingSchoolCoursePermit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download Issued Form By Id
 */
export const getIssuedForm = <ThrowOnError extends boolean = false>(options: Options<GetIssuedFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIssuedFormResponses, GetIssuedFormErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/issued/{id}',
        ...options
    });
};

/**
 * Fetch Link To Issued Form By Id
 */
export const getIssuedFormLink = <ThrowOnError extends boolean = false>(options: Options<GetIssuedFormLinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIssuedFormLinkResponses, GetIssuedFormLinkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/forms/issued/{id}/link',
        ...options
    });
};

/**
 * Send form email template
 */
export const emailIssuedForm = <ThrowOnError extends boolean = false>(options: Options<EmailIssuedFormData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EmailIssuedFormResponses, EmailIssuedFormErrors, ThrowOnError>({
        url: '/forms/issued/{id}/email',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Calendar Feed in ICS format
 */
export const getCalendarFeed = <ThrowOnError extends boolean = false>(options: Options<GetCalendarFeedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCalendarFeedResponses, GetCalendarFeedErrors, ThrowOnError>({
        responseType: 'text',
        url: '/calendar/feed',
        ...options
    });
};

/**
 * Delete charge
 */
export const deleteCharge = <ThrowOnError extends boolean = false>(options: Options<DeleteChargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteChargeResponses, DeleteChargeErrors, ThrowOnError>({
        url: '/finance/charges',
        ...options
    });
};

/**
 * Get charges
 */
export const listCharges = <ThrowOnError extends boolean = false>(options?: Options<ListChargesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListChargesResponses, ListChargesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/charges',
        ...options
    });
};

/**
 * Update charge
 */
export const createCharge = <ThrowOnError extends boolean = false>(options: Options<CreateChargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateChargeResponses, CreateChargeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/charges',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get charge
 */
export const getCharge = <ThrowOnError extends boolean = false>(options: Options<GetChargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChargeResponses, GetChargeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/charges/{id}',
        ...options
    });
};

/**
 * Update charge
 */
export const updateCharge = <ThrowOnError extends boolean = false>(options: Options<UpdateChargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateChargeResponses, UpdateChargeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/charges/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Void a charge
 * Marks a charge as voided with a reason
 */
export const voidCharge = <ThrowOnError extends boolean = false>(options: Options<VoidChargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<VoidChargeResponses, VoidChargeErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/charges/{id}/void',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve payments
 * Returns a list of payments. Can be filtered by student ID.
 *
 */
export const listPayments = <ThrowOnError extends boolean = false>(options?: Options<ListPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPaymentsResponses, ListPaymentsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payments',
        ...options
    });
};

/**
 * Create a new payment
 * Create a new payment record. The request body must conform to the PaymentForm schema. Note that the `id` field should be null when creating a new payment.
 *
 */
export const createPayment = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePaymentResponses, CreatePaymentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get payment
 */
export const getPayment = <ThrowOnError extends boolean = false>(options: Options<GetPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPaymentResponses, GetPaymentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payments/{id}',
        ...options
    });
};

/**
 * Update an existing payment
 * Update an existing payment record. The `paymentId` path parameter identifies the payment to update. The request body must conform to the PaymentForm schema.
 *
 */
export const updatePayment = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePaymentResponses, UpdatePaymentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payments/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Void a payment
 * Marks a payment as voided with a reason
 */
export const voidPayment = <ThrowOnError extends boolean = false>(options: Options<VoidPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<VoidPaymentResponses, VoidPaymentErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payments/{id}/void',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get list of discounts
 */
export const listDiscounts = <ThrowOnError extends boolean = false>(options?: Options<ListDiscountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListDiscountsResponses, ListDiscountsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/discounts',
        ...options
    });
};

/**
 * Retrieve payment methods
 * Returns a list of payment methods filtered by type and status. The 'type' query parameter can be 'all', 'payments', or 'refunds' (default is 'all'). The 'status' query parameter is optional and filters based on whether a payment method is enabled.
 *
 */
export const listPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<ListPaymentMethodsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPaymentMethodsResponses, ListPaymentMethodsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/payment-methods',
        ...options
    });
};

/**
 * Retrieve refunds
 * Returns a list of refunds. Can be filtered by student ID. Students can only access their own refunds.
 *
 */
export const listRefunds = <ThrowOnError extends boolean = false>(options?: Options<ListRefundsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRefundsResponses, ListRefundsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/refunds',
        ...options
    });
};

/**
 * Create a new refund
 * Create a new refund record. The request body must conform to the RefundForm schema. Note that the `id` field should be null when creating a new refund.
 *
 */
export const createRefund = <ThrowOnError extends boolean = false>(options: Options<CreateRefundData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRefundResponses, CreateRefundErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/refunds',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve a specific refund
 * Returns a specific refund by ID. Students can only access their own refunds.
 *
 */
export const getRefund = <ThrowOnError extends boolean = false>(options: Options<GetRefundData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRefundResponses, GetRefundErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/refunds/{id}',
        ...options
    });
};

/**
 * Update an existing refund
 * Update an existing refund record. The `id` path parameter identifies the refund to update. The request body must conform to the RefundForm schema.
 *
 */
export const updateRefund = <ThrowOnError extends boolean = false>(options: Options<UpdateRefundData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateRefundResponses, UpdateRefundErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/refunds/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Void a refund
 * Marks a refund as voided with a reason
 */
export const voidRefund = <ThrowOnError extends boolean = false>(options: Options<VoidRefundData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<VoidRefundResponses, VoidRefundErrors, ThrowOnError>({
        responseType: 'json',
        url: '/finance/refunds/{id}/void',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get email and/or SMS template and available merge tags
 * Retrieves the email/SMS template for a specific record and includes the list of applicable merge tags.
 */
export const getTemplate = <ThrowOnError extends boolean = false>(options: Options<GetTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/templates/{templateKey}/{id}',
        ...options
    });
};

/**
 * Update email and/or SMS template for a specific record
 * Updates the email, SMS, or both templates for a record identified by the template key and ID. Supports partial updates.
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError>({
        responseType: 'json',
        url: '/templates/{templateKey}/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List available report definitions
 * Returns all available report definitions with dynamic select options populated from the database
 */
export const listReports = <ThrowOnError extends boolean = false>(options?: Options<ListReportsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReportsResponses, ListReportsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/reports',
        ...options
    });
};

/**
 * Get a single report definition
 * Returns a single report definition by ID with dynamic select options populated
 */
export const getReport = <ThrowOnError extends boolean = false>(options: Options<GetReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReportResponses, GetReportErrors, ThrowOnError>({
        responseType: 'json',
        url: '/reports/{reportId}',
        ...options
    });
};

/**
 * Generate and download a report
 * Generates a report with the specified parameters and format, returning the file as a download
 */
export const generateReport = <ThrowOnError extends boolean = false>(options: Options<GenerateReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateReportResponses, GenerateReportErrors, ThrowOnError>({
        responseType: 'text',
        url: '/reports/{reportId}/generate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getMyLearningCourses = <ThrowOnError extends boolean = false>(options?: Options<GetMyLearningCoursesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyLearningCoursesResponses, GetMyLearningCoursesErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/my-courses',
        ...options
    });
};

export const listCurricula = <ThrowOnError extends boolean = false>(options?: Options<ListCurriculaData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCurriculaResponses, ListCurriculaErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/curricula',
        ...options
    });
};

export const createCurriculum = <ThrowOnError extends boolean = false>(options: Options<CreateCurriculumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCurriculumResponses, CreateCurriculumErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/curricula',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCurriculum = <ThrowOnError extends boolean = false>(options: Options<GetCurriculumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCurriculumResponses, GetCurriculumErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/curricula/{id}',
        ...options
    });
};

export const updateCurriculum = <ThrowOnError extends boolean = false>(options: Options<UpdateCurriculumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCurriculumResponses, UpdateCurriculumErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/curricula/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const publishCurriculum = <ThrowOnError extends boolean = false>(options: Options<PublishCurriculumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PublishCurriculumResponses, PublishCurriculumErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/curricula/{id}/publish',
        ...options
    });
};

export const getCourseCurriculumAssignment = <ThrowOnError extends boolean = false>(options: Options<GetCourseCurriculumAssignmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCourseCurriculumAssignmentResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/courses/{courseId}/curriculum',
        ...options
    });
};

export const assignCurriculumToCourse = <ThrowOnError extends boolean = false>(options: Options<AssignCurriculumToCourseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AssignCurriculumToCourseResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/learning/admin/courses/{courseId}/curriculum',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getLearningCourse = <ThrowOnError extends boolean = false>(options: Options<GetLearningCourseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLearningCourseResponses, GetLearningCourseErrors, ThrowOnError>({
        responseType: 'json',
        url: '/learning/courses/{courseId}/curriculum',
        ...options
    });
};

export const updateLearningProgress = <ThrowOnError extends boolean = false>(options: Options<UpdateLearningProgressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateLearningProgressResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/learning/courses/{courseId}/items/{itemId}/progress',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const submitLearningQuiz = <ThrowOnError extends boolean = false>(options: Options<SubmitLearningQuizData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitLearningQuizResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/learning/courses/{courseId}/items/{itemId}/quiz',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};